import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    maritals: [],
    maritalsCount: 0,
    marital: {},
    maritalSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getMaritals(state) {
      return state.maritals
    },
    getMaritalsCount(state) {
      return state.maritalsCount
    },
    getMarital(state) {
      return state.marital
    },
    getMaritalSaveStatus(state) {
      return state.maritalSave
    },
  },
  mutations: {
    MARITALS_LIST(state, data) {
      state.maritals = data
    },
    MARITAL_VIEW(state, data) {
      state.marital = data
    },
    MARITALS_COUNT(state, data) {
      state.maritalsCount = data
    },
    MARITAL_SAVE(state, data) {
      state.maritalSave = data
    },
  },
  actions: {
    maritalsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/maritals', data)
        .then(response => {
          commit('MARITALS_LIST', response.data.data)
          commit('MARITALS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    maritalView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'maritals.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/maritals', data)
        .then(response => {
          commit('MARITAL_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    maritalSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/maritals/saveData', data)
        .then(response => {
          commit('MARITAL_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
